export enum TrustType {
  'Discretionary / Family trust' = 'familyTrust',
  'Charitable Trust' = 'charitableTrust',
  'Testamentary Trust' = 'testamentaryTrust',
  'Fixed Unit Trust' = 'unitTrust',
  'Bare Trust' = 'bareTrust',
  'Hybrid Unit Trust' = 'hybridUnitTrust',
  'Other Type' = 'otherType',
  'Registered Managed Investment Scheme' = 'asic',
  'Unregistered Managed Investment Scheme' = 'mis',
  'Regulated under a Commonwealth statutory regulator' = 'regulatedUnderCommonwealthStatutoryRegulator',
  'Government Superannuation Fund' = 'governmentSuperannuationFund',
  'Revocable' = 'Revocable',
  'Irrevocable' = 'Irrevocable',
  'QTIP' = 'QTIP',
  'Special Needs Trust' = 'SpecialNeedsTrust',
  'Blind Trust' = 'BlindTrust',
  'Parallel Trust' = 'parallelTrust',
  'Single Trust' = 'singleTrust',
  'NextGen Trust' = 'nextGenTrust',
  'Business Trust' = 'businessTrust',
}

export const trustTypeMapping: Record<string, TrustType> = {
  discretionary: TrustType['Discretionary / Family trust'],
  family: TrustType['Discretionary / Family trust'],
  charitable: TrustType['Charitable Trust'],
  testamentary: TrustType['Testamentary Trust'],
  'fixed unit': TrustType['Fixed Unit Trust'],
  'unit trust': TrustType['Fixed Unit Trust'],
  bare: TrustType['Bare Trust'],
  hybrid: TrustType['Hybrid Unit Trust'],
  other: TrustType['Other Type'],
  'registered managed investment scheme': TrustType['Registered Managed Investment Scheme'],
  'unregistered managed investment scheme': TrustType['Unregistered Managed Investment Scheme'],
  asic: TrustType['Registered Managed Investment Scheme'],
  mis: TrustType['Unregistered Managed Investment Scheme'],
  'regulated under': TrustType['Regulated under a Commonwealth statutory regulator'],
  'commonwealth statutory regulator':
    TrustType['Regulated under a Commonwealth statutory regulator'],
  'government superannuation': TrustType['Government Superannuation Fund'],
  'superannuation fund': TrustType['Government Superannuation Fund'],
  revocable: TrustType['Revocable'],
  irrevocable: TrustType['Irrevocable'],
  qtip: TrustType['QTIP'],
  'special needs': TrustType['Special Needs Trust'],
  blind: TrustType['Blind Trust'],
  parallel: TrustType['Parallel Trust'],
  single: TrustType['Single Trust'],
  nextgen: TrustType['NextGen Trust'],
  business: TrustType['Business Trust'],
};

export function detectTrustType(input?: string): TrustType | undefined {
  if (!input) return;
  const normalized = input.toLowerCase();

  for (const [key, type] of Object.entries(trustTypeMapping)) {
    if (normalized.includes(key)) {
      return type;
    }
  }

  return;
}

export const trustTypeAUSUnregulatedOptions = [
  { label: 'Discretionary / Family trust', value: 'familyTrust' },
  { label: 'Charitable Trust', value: 'charitableTrust' },
  { label: 'Testamentary Trust', value: 'testamentaryTrust' },
  { label: 'Fixed Unit Trust', value: 'unitTrust' },
  { label: 'Bare Trust', value: 'bareTrust' },
  { label: 'Hybrid Unit Trust', value: 'hybridUnitTrust' },
  { label: 'Other Type', value: 'otherType' },
];

export const trustTypeAUSRegulatedOptions = [
  { label: 'Registered Managed Investment Scheme', value: 'asic' },
  { label: 'Unregistered Managed Investment Scheme', value: 'mis' },
  {
    label: 'Regulated under a Commonwealth statutory regulator',
    value: 'regulatedUnderCommonwealthStatutoryRegulator',
  },
  { label: 'Government Superannuation Fund', value: 'governmentSuperannuationFund' },
];

export const trustTypeUSAUnregulatedOptions = [
  { label: 'Revocable', value: 'Revocable' },
  { label: 'Irrevocable', value: 'Irrevocable' },
  { label: 'QTIP', value: 'QTIP' },
  { label: 'Special Needs Trust', value: 'SpecialNeedsTrust' },
  { label: 'Blind Trust', value: 'BlindTrust' },
  { label: 'Testamentary Trust', value: 'testamentaryTrust' },
];

export const trustTypeNZLOptions = [
  { label: 'Family Trust', value: 'familyTrust' },
  { label: 'Parallel Trust', value: 'parallelTrust' },
  { label: 'Single Trust', value: 'singleTrust' },
  { label: 'NextGen Trust', value: 'nextGenTrust' },
  { label: 'Business Trust', value: 'businessTrust' },
  { label: 'Charitable Trust', value: 'charitableTrust' },
];
